var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[_vm.$vuetify.breakpoint.name, _vm.showOnlySettingsNavigation ? 'setting-sidebar-z-250' : '']},[_c(_vm.layout,{tag:"component",staticClass:"content-wrap"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }